import * as constants from './constants';

const INITIAL_STATE = {
  userLocation: { latitude: null, longitude: null },
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_USER_LOCATION_VALUE:
      return Object.assign({}, state, {
        userLocation: action.payload.userLocation,
      });
    default:
      return state;
  }
};

export default exportedObject;
